import { DebouncedFunc, debounce } from "lodash";
import { useCallback, useEffect, useRef } from "react";

export interface UseDebounceResult {
  cancel: () => void;
  debounce: (cb: () => Promise<void> | void) => void;
}

export const useDebounce = (
  timeout: number,
  options?: { leading?: boolean; preventCancelOnUnmount?: boolean },
): UseDebounceResult => {
  const debounceRef = useRef<DebouncedFunc<() => Promise<void>> | null>(null);

  const onDebounce = useCallback(async (cb: () => Promise<void> | void) => {
    debounceRef.current?.cancel();
    debounceRef.current = debounce(cb, timeout, { leading: options?.leading });
    debounceRef.current();
  }, []);

  useEffect(() => {
    return () => {
      if (options?.preventCancelOnUnmount) {
        return;
      }
      debounceRef.current?.cancel();
    };
  }, []);

  return {
    debounce: onDebounce,
    cancel: () => debounceRef.current?.cancel(),
  };
};
